import { render, staticRenderFns } from "./PatientRechargeStatistics.vue?vue&type=template&id=360ba6d8&scoped=true"
import script from "./PatientRechargeStatistics.vue?vue&type=script&lang=js"
export * from "./PatientRechargeStatistics.vue?vue&type=script&lang=js"
import style0 from "./PatientRechargeStatistics.vue?vue&type=style&index=0&id=360ba6d8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "360ba6d8",
  null
  
)

export default component.exports